<template>
	<div ref="container" v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)" class="obj-container"></div>
</template>

<script>
	import * as THREE from 'three'
	import {
		OBJLoader
	} from 'three/examples/jsm/loaders/OBJLoader'
	import {
		OrbitControls
	} from 'three/examples/jsm/controls/OrbitControls'

	export default {
		name: 'ObjViewer',
		props: {
			url: {
				type: String,
				required: true,
			}
		},
		data() {
			return {
				loading: true,
			}
		},
		mounted() {
			this.init()
		},
		beforeDestroy() {
			cancelAnimationFrame(this.raf)
			this.renderer.dispose()
		},
		methods: {
			init() {
				const width = this.$refs.container.clientWidth
				const height = this.$refs.container.clientHeight || 500

				// 场景
				this.scene = new THREE.Scene()
				this.scene.background = new THREE.Color(0xf5f5f5)

				// 相机
				this.camera = new THREE.PerspectiveCamera(60, width / height, 0.1, 1000)
				this.camera.position.set(0, 2, 5)

				// 渲染器
				this.renderer = new THREE.WebGLRenderer({
					antialias: true
				})
				this.renderer.setSize(width, height)
				this.$refs.container.appendChild(this.renderer.domElement)

				// 灯光
				const light1 = new THREE.DirectionalLight(0xffffff, 1)
				light1.position.set(5, 10, 7)
				this.scene.add(light1)
				this.scene.add(new THREE.AmbientLight(0xffffff, 0.6))

				// 控制器
				this.controls = new OrbitControls(this.camera, this.renderer.domElement)

				// 加载 OBJ
				const loader = new OBJLoader()
				loader.load(
					this.url,
					object => {
						this.loading = false
						object.scale.set(1, 1, 1)
						this.scene.add(object)
						this.fitModel(object)
						this.animate()
					},
					xhr => {
						console.log('加载进度', (xhr.loaded / xhr.total) * 100 + '%')
					},
					err => {
						this.loading = false
						console.error('OBJ 加载失败', err)
					}
				)
			},
			fitModel(obj) {
				const box = new THREE.Box3().setFromObject(obj)
				const size = box.getSize(new THREE.Vector3())
				const center = box.getCenter(new THREE.Vector3())

				obj.position.sub(center)

				const maxSize = Math.max(size.x, size.y, size.z)
				const fov = this.camera.fov * Math.PI / 180
				const distance = maxSize / Math.tan(fov / 2)

				this.camera.position.set(0, 0, distance * .8)
				this.camera.near = maxSize / 100
				this.camera.far = maxSize * 100
				this.camera.updateProjectionMatrix()

				this.controls.target.set(0, 0, 0)
				this.controls.update()
			},
			animate() {
				this.raf = requestAnimationFrame(this.animate)
				this.controls.update()
				this.renderer.render(this.scene, this.camera)
			}
		}
	}
</script>

<style scoped>
	.obj-container {
		width: 10.8rem;
		height: 5.6rem;
	}
</style>
<style>
	.el-loading-spinner {
		i {
			color: rgba(255, 255, 255, .6) !important;
		}

		.el-loading-text {
			color: rgba(255, 255, 255, .6) !important;
		}
	}
</style>